__turbopack_context__.v({
  "aboveLink": "OH4oJW_aboveLink",
  "cardToolTip": "OH4oJW_cardToolTip",
  "cardWrapper": "OH4oJW_cardWrapper",
  "clickableItem": "OH4oJW_clickableItem",
  "disclosureLink": "OH4oJW_disclosureLink",
  "etfCard": "OH4oJW_etfCard",
  "fundamentalItem": "OH4oJW_fundamentalItem",
  "fundamentalItemsWrapper": "OH4oJW_fundamentalItemsWrapper",
  "fundamentals": "OH4oJW_fundamentals",
  "infoCircleIcon": "OH4oJW_infoCircleIcon",
  "layoutFloating": "OH4oJW_layoutFloating",
  "quoteName": "OH4oJW_quoteName",
  "quoteOverview": "OH4oJW_quoteOverview",
  "quoteTooltip": "OH4oJW_quoteTooltip",
  "sectionTitle": "OH4oJW_sectionTitle",
  "stretchedLink": "OH4oJW_stretchedLink",
  "tickerName": "OH4oJW_tickerName",
});
